const CHARS_PER_MINUTE = 1400; // mirrors article.service.ts (10 chars/s × 60)

export function getReadTimeFromChars(contentLength: number): string {
  const totalMinutes = contentLength / CHARS_PER_MINUTE;
  const hours = Math.floor(totalMinutes / 60);
  let minutes = Math.round(totalMinutes % 60);

  const roundedLength = (hours * 60 + minutes) * CHARS_PER_MINUTE;
  if (roundedLength < contentLength) minutes += 1;
  if (hours === 0 && minutes === 0) minutes = 1;

  let result = '';
  if (hours > 0) result += `${hours} hr `;
  result += `${minutes} min read`;
  return result.trim();
}

/** Converts a word count to read time (approx 6 chars per word). */
export function getReadTimeFromWords(wordCount: number): string {
  return getReadTimeFromChars(wordCount * 6);
}
